<template>
    <div class="game_info">
        <van-overlay :show="!infoShow">
            <div class="game_info_wrapper">
                <img src="@/assets/images/game/close.png" @click="start" class="game_info_wrapper_close" />
                <div class="game_info_wrapper_pic">
                    暂停
                </div>
                <div class="game_info_wrapper_cen">
                     <img src="@/assets/images/game/gir-info.png" class="game_info_wrapper_cry" />
                    <p>{{infoMsg}}</p>
                </div>
                
                <div class="game_info_wrapper_button">
                     <div class="game_info_wrapper_button_no" @click="goback">
                         返回关卡
                     </div>
                     <div class="game_info_wrapper_button_start" @click="start">
                         开始游戏
                     </div>
                     <div class="game_info_wrapper_button_yes" @click="restart">
                         重新开始
                     </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>
<script>
export default {
    name: 'pause-info',
    props:['infoShow','infoMsg'],
    data () {
        return {

        }
    },
    methods:{
        restart() {
            this.$emit('restart');
        },
        goback() {
            this.$emit('goback');
        },
        start() {
            this.$emit('start');
        }
    }
}
</script>
<style lang='scss' scoped>
.van-overlay {
    z-index: 99;
    display: flex;
    justify-content: center;
    align-items: center;
    .game_info_wrapper {
        width: 338px;
        height: 173px;
        background: url(./../../assets/images/game/pause-bg.png);
        background-size: cover;
        position: relative;
        .game_info_wrapper_close {
            position: absolute;
            width: 26px;
            height: 26px;
            right: -10px;
            top: -10px;
        }
        .game_info_wrapper_cen {
            display: flex;
            justify-content: center;
            .game_info_wrapper_cry {
                width: 83px;
                height: 89px;
            }
             p {
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                text-align: center;
                margin-top: 10px;
                line-height: 89px;
            }
        }
        
        .game_info_wrapper_pic {
            width: 182px;
            height: 49px;
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 44px;
            background: url(./../../assets/images/game/tui.png);
            background-size: cover;
            margin-left: 78px;
            margin-top: -30px;
        }
        .game_info_wrapper_button {
            display: flex;
            justify-content: center;
            // margin-top: 10px;
            .game_info_wrapper_button_no {
                width: 82px;
                height: 31px;
                background: url(./../../assets/images/game/no.png);
                background-size: 100% 100%;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 29px;
                text-shadow: 0px 2px 1px #6381FF;
                text-align: center;
            }
            .game_info_wrapper_button_start {
                width: 102px;
                height: 38px;
                background: url(./../../assets/images/game/start-info.png);
                background-size: 100% 100%;
                margin-left: 12px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 35px;
                text-shadow: 0px 2px 1px #fe8c62;
                text-align: center;
                margin-top: -10px;
            }
            .game_info_wrapper_button_yes {
                width: 82px;
                height: 31px;
                background: url(./../../assets/images/game/yes.png);
                background-size: 100% 100%;
                margin-left: 12px;
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 29px;
                text-shadow: 0px 2px 1px #fe8c62;
                text-align: center;
            }
        }
    }
}

</style>
